/**
 * Review status values from URL params (application create/review flow).
 * Used to control step count, guarantor step visibility, draft/guarantor API usage.
 */

/** Flow with Guarantor step: step 7 = Guarantor, step 8 = Final Confirmation, step 9 = Application */
export const REVIEW_STATUS_GUARANTOR = "2";

/** Guarantor flow variant (no step 9, step 8 = Application Completion) */
export const REVIEW_STATUS_3 = "3";

/** Guarantor flow variant (no step 9, step 8 = Application Completion) */
export const REVIEW_STATUS_4 = "4";

/** All review statuses that use guarantor API and skip draft save */
export const REVIEW_STATUS_GUARANTOR_FLOW_VALUES = [REVIEW_STATUS_GUARANTOR, REVIEW_STATUS_3, REVIEW_STATUS_4] as const;

export type ReviewStatusGuarantorFlow = (typeof REVIEW_STATUS_GUARANTOR_FLOW_VALUES)[number];

/** True when status is "2" | "3" | "4" (guarantor flow) */
export const isGuarantorFlowReviewStatus = (status: string | null | undefined): status is ReviewStatusGuarantorFlow =>
  status === REVIEW_STATUS_GUARANTOR || status === REVIEW_STATUS_3 || status === REVIEW_STATUS_4;

/** True when status is "2" (flow has dedicated Guarantor step 7) */
export const hasGuarantorStep = (status: string | null | undefined): boolean => status === REVIEW_STATUS_GUARANTOR;
